import React, { useState } from 'react'
import { useTranslation } from '../../locale/useTranslation';
import { ENTITYNAME, LOGEVENT, MODULE, TOAST_TYPES } from '../constant/constant';
import * as API from "../../framework/API/api"
import BossDialog from '../../components/BossDialog';
import { EditPageHeader } from '../../components/EditPageHeader';
import { utility } from '../utility/utilityProvider';
import ToastNotification from '../../components/ToastNotification';

const OttAggregatorEditForm = (props) => {
    const lang = useTranslation();

    const blankDataItem = {
        ...props.item,
        Description: props?.item?.copy ? "Copy of " + props?.item?.Description : props?.item?.Description ?? "",
        Archive: props?.item?.Archive ?? false,
    }

    const [dataItem, setDataItem] = useState(blankDataItem);

    const onChange = (e) => {
        if (e.target.name === 'Archive') {
            setDataItem({ ...dataItem, Archive: !dataItem.Archive });
        }
        else {
            setDataItem({ ...dataItem, [e.target.name]: e.target.value });
        }
    }

    const isValid = () => {

        if (dataItem.Description == undefined || dataItem.Description == "") {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_enter_description_error_message });
            return false;
        }
        return true;

    }

    const handleSubmit = async () => {
        if (!isValid()) return;
        const saveData = {
            _id: dataItem?._id,
            SID: dataItem?.SID,
            Description: dataItem?.Description,
            Archive: dataItem?.Archive ?? false,
            checkDuplicate: true,
            query: [["Description", "=", dataItem.Description]]
        }
        console.log(saveData);
        const res = await API.saveData(ENTITYNAME.Ott_Aggregator, saveData);
        if (res.success) {
            let logData = { event: res.message == "updated" ? LOGEVENT.UPDATE : LOGEVENT.INSERT, module: MODULE.OTT_AGGREGATOR, data: res.data, message: res.message };
            API.SaveLogs(logData);
            props.cancelEdit();
            props.refresh();
            utility.deleteLocalStorageItem(ENTITYNAME.Ott_Aggregator);
        } else {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: res.message });
        }
    }

    return (
        <>
            <BossDialog
                title={props?.item?.Description ?? lang.ott_aggregator_dialog_header}
                onClose={props.cancelEdit}
                width={"550px"}
            >
                <EditPageHeader title={""} onSubmit={handleSubmit} onCancel={props.cancelEdit} showTitle={false} />

                <div className='row mt-2'>
                    <div className='col-12'>
                        <div className='row mt-2'>
                            <div className='col-6'>
                                <label>{lang.description_label} *</label>
                                <input
                                    name={"Description"}
                                    type="text"
                                    className="form-control form-control-sm"
                                    onChange={onChange}
                                    value={dataItem.Description}
                                />
                            </div>
                            <div className='col-6'>
                                <input
                                    style={{ border: "1px solid grey", marginTop: "26px" }}
                                    name={"Archive"}
                                    type='checkbox'
                                    onChange={onChange}
                                />
                                <label className="ml-2">{lang.archive}</label>
                            </div>
                        </div>
                    </div>
                </div>
            </BossDialog >
        </>
    )
}

export default OttAggregatorEditForm